import { ThemeType } from 'theme/jss-types';

export const editHeadersStyles = (theme: ThemeType) => ({
    searchInput: {
        marginBottom: '16px',
    },
    listItemStyle: {
        marginBottom: '10px',
        backgroundColor: '#ffffff',
        borderRadius: '4px',
        paddingLeft: '8px',
        paddingRight: '8px',
        height: '36px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        cursor: 'pointer',
    },
    mainDiv: {
        display: 'flex',
        maxHeight: '450px',
    },
    leftDiv: {
        width: '40%',
        display: 'flex',
        flexDirection: 'column',
    },
    searchStyle: {
        padding: '12px',
        border: '1px solid #E8E8E8',
    },
    rightDiv: {
        border: '1px solid #E8E8E8',
        padding: '12px',
        width: '60%',
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    rightDivScrollElement: {
        display: 'flex',
    },
    rightDivStickyHeader: {
        display: 'flex',
        marginBottom: '12px',
        borderBottom: '1px solid #E8E8E8',
        padding: '11px 0px',
    },
    rightDivColumnElement: {
        flex: '0 0 auto',
        justifyItems: 'center',
        paddingLeft: '32px',
        paddingRight: '28px',
    },
    rightDivListElement: {
        width: '100%',
    },
    rightDivColumnHeader: {
        fontWeight: 400,
        fontSize: '14px',
        color: '#424242',
        paddingLeft: '10px',
        width: '28%',
    },
    rightDivColumnMandatory: {
        fontWeight: 400,
        fontSize: '14px',
        color: '#424242',
        paddingRight: '12px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'end',
    },
    rightDivListHeader: {
        fontWeight: 400,
        fontSize: '14px',
        color: '#424242',
        width: '85%',
        display: 'flex',
        justifyContent: 'left',
    },
    checkboxDiv: {
        overflow: 'auto',
        border: '1px solid #E8E8E8',
        height: '100%',
        padding: '16px',
    },
    checkBoxStyle: {
        marginBottom: '10px',
        backgroundColor: 'transparent',
        borderRadius: '4px',
    },
    customPrimaryButton: {
        backgroundColor: theme.primaryColor,
        color: theme.primaryColor,
    },
    columnStyle: {
        marginBottom: '8px',
        padding: '9px 8px',
    },
    crossButton: {
        marginLeft: 'auto',
        cursor: 'pointer',
        background: 'none !important',
        border: 'none !important',
        color: 'red',
        fontWeight: 'bold',
    },
    sortableItemStyle: {
        display: 'flex',
        alignItems: 'center',
        padding: '4px 8px',
        borderRadius: '4px',
        backgroundColor: '#d5e9ff',
        marginBottom: '8px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
        marginLeft: '14px',
        width: '100%',
    },
    dragIconStyle: {
        display: 'inline-block',
        width: '12px',
        height: '11px',
        backgroundImage: 'radial-gradient(circle, #999 20%, transparent 20%)',
        backgroundSize: '4px 4px',
        backgroundRepeat: 'repeat',
    },
    dragHandleStyle: {
        display: 'inline-block',
        cursor: 'grab',
        marginRight: '8px',
    },
    noResultsText: {
        display: 'flex',
        justifyContent: 'center',
        margin: 'auto',
        padding: '8px',
        color: '#999',
    },
    headerElementStyle: {
        width: 240,
        whiteSpace: 'nowrap',
        overflow: 'auto',
        textOverflow: 'ellipsis',
        cursor: 'pointer',
    },
    headerElement: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        paddingRight: '24px',
    },
    draggingItem: {
        opacity: 0.5,
    },
    editModalHeader: {
        padding: '16px 24px',
        backgroundColor: theme.primaryColor,
        alignItems: 'center',
        justifyContent: 'space-between',
        display: 'flex',
    },
    editModal: {
        '& .ant-modal-header': {
            padding: '0px !important',
        },
    },
    mandatorySwitch: {
        marginLeft: '6%',
    },
});
